'use client';

import clsx from 'clsx';
import type { CSSProperties } from 'react';

import { SDSImageWrapper } from '@repo/sds/components/_internal/SDSImageWrapper';
import { SDSSkeleton } from '@repo/sds/components/_internal/SDSSkeleton';
import { useSDSConfig } from '@repo/sds/providers/SDSProvider';

import '@repo/sds/components/SDSImage/SDSImage.scss';

export interface SDSImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  dataTestId?: string;
  wrapperClassName?: string; // For SDSImageWrapper
  onLoad?: () => void;
  onError?: () => void;

  // Next.js/advanced props (passed through to configured component)
  width?: number;
  height?: number;
  fill?: boolean;
  quality?: number;
  sizes?: string;
  priority?: boolean;
  loading?: 'eager' | 'lazy';
  unoptimized?: boolean;
  style?: CSSProperties;
  isLoading?: boolean;
}

export function SDSImage({ wrapperClassName, isLoading, src, ...imageProps }: SDSImageProps) {
  const { imageComponent: ImageComponent } = useSDSConfig();

  if (isLoading) {
    return <SDSSkeleton width="100%" height="100%" className={clsx('SDSImage__skeleton')} />;
  }

  if (src === null) {
    return null;
  }

  return (
    <SDSImageWrapper wrapperClassName={wrapperClassName}>
      <ImageComponent src={src} {...imageProps} />
    </SDSImageWrapper>
  );
}
